import { ReactElement } from 'react';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
  FormPublicFragment,
} from '../../graphql/fragment/form.public.fragment';

export interface LayoutProps {
  form: FormPublicFragment;
  // customFormJson - json data for custom forms, all from ./root/json
  // custom forms has their questions categorized into categories and currently, we do not have this sort of system
  // in the db so we just manually make it in a json file
  // they have questions that collect the user answers into a "score" (integer) and we average it into a final score in the end
  // a "question" has two things in the json file - an id and the category it belongs to, the id and the category name
  // the questions are in order of the form and we grab it by just console logging
  // a "category" also has two things - the name and the max score
  // the max score is the (number of questions X max point for a question)
  // the "chartCategories" in the JSON is just the categories with some placed into an array for the radar chart to split
  // the text onto mulitple lines
  customFormJson?: any;
  // renderCustomFormEndPage - some have a special end page different from the default one so we give a function that renders the end page
  // with the required data to render it
  renderCustomFormEndPage?: (params: any) => ReactElement;
  renderCustomFormStartPage?: (params: any) => ReactElement;
  startPageFields?: FormPublicFieldFragment[];
  setSubmissionId?: (submissionId: string) => void;
}

export enum ACTIONS {
  ADD_SUBMISSION = 'ADD_SUBMISSION',
  DELETE_SUBMISSIONS = 'DELETE_SUBMISSIONS',
}

export interface SubmissionsState {
  field: string;
  data: string;
}

export interface SubmissionsAction {
  type: ACTIONS;
  payload: SubmissionsState;
}

export interface ShareAction {
  type: ACTIONS;
  payload: SubmissionsState;
}

export interface CustomFormEndPageProps {
  scores: number[];
  design: FormPublicDesignFragment;
  jsonData: any;
}
